import axios from "axios";
import { encryptData } from "../utils/encryption";

const dataToEncrypt = process.env.NEXT_PUBLIC_KNOWLEDGE_FUNC_KEY;
const encryptedData = encryptData(dataToEncrypt);

const axiosInstanceknwinfosvcGet2 = axios.create({
  baseURL: process.env.NEXT_PUBLIC_API_KNOWLEDGE_ARTICLE_URL,
  headers: {
    "Content-Type": "application/json",
    "x-function-key": encryptedData,
    "Content-Security-Policy":
      "default-src 'self'; script-src 'self' 'unsafe-inline'; style-src 'self' 'unsafe-inline'; img-src 'self' data:; object-src 'none'",
  },
});

axiosInstanceknwinfosvcGet2.interceptors.request.use(
  (config) => {
    return config;
  },
  (error) => {
    console.log("Request error:", error);
    return Promise.reject(error);
  }
);

axiosInstanceknwinfosvcGet2.interceptors.response.use(
  async (response) => {
    return response?.data;
  },
  async (error) => {
    console.log("Response error:", error);
    if (error.response.status === 401 || error.response.status === 403) {
    }
    return Promise.reject(error);
  }
);

export default axiosInstanceknwinfosvcGet2;
